import { Fragment } from "react";
import { EditActions, MetaTags, PageLayout, TabPanel } from "../../components";
import useLocales from "../../hooks/useLocales";
import { Outlet, useParams } from "react-router-dom";
import { useGetOneByIdQuery } from "../../features/api/Api";

const CustomerWorkOrderDetail = () => {
  const { translate } = useLocales();
  const { id } = useParams();
  const { data: workorder } = useGetOneByIdQuery<any>({
    resource: `fixity/workorder/workorder`,
    id: id,
  });
  const panelLabels = [
    { label: translate("tabs.header.general"), path: "general" },
    {
      label: translate("tabs.header.document"),
      path: "document",
    },
  ];
  return (
    <Fragment>
      <MetaTags
        title={workorder?.data?.workOrderNumber}
        keyword="Fixity, Work Order, Edit"
        description="Work Order Edit Page"
      />
      <PageLayout
        title={workorder?.data?.workOrderNumber}
        actions={
          <EditActions
            path="customers/:id/customer_workorders"
            name={translate("actions.list")}
            icon="icon-format_list_bulleted"
          />
        }
      >
        <TabPanel labels={panelLabels}>
          <div style={{ paddingLeft: "30px", paddingRight: "30px" }}>
            <Outlet />
          </div>
        </TabPanel>
      </PageLayout>
    </Fragment>
  );
};

export default CustomerWorkOrderDetail;
